/* app/js/src/components/channel/channel-wizard/step2/substep1.scss */
.cursor-pointer {
  cursor: pointer;
}
.main {
  display: flex;
  margin-bottom: 25px;
}
.main .svg-icon {
  margin-left: 15px;
  cursor: pointer;
}
.ts-action {
  display: flex;
  margin-bottom: 15px;
}
.ts-action .label {
  white-space: nowrap;
  width: 230px;
}
.preview-settings {
  margin-top: 30px;
}
/*# sourceMappingURL=substep1.css.map */
